import { Grid, makeStyles, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
	title: {
		marginTop: '25px',
	},
	boldText: {
		fontWeight: 'bold',
	},
	justifyText: {
		textAlign: 'justify',
	},
}));

const Help: FC = () => {
	const classes = useStyles();

	const { t } = useTranslation('help');

	return (
		<>
			<Grid item xs={1} sm={2} />
			<Grid item xs={10} sm={8}>
				<Typography className={classes.title} variant="h6" paragraph>
					{t('search_title')}
				</Typography>
				<Typography className={classes.justifyText} variant="body1" paragraph>
					{t('search_text_prefix')}
					<b>{t('search_text_bold')}</b>
					{t('search_text_suffix')}
				</Typography>
				<Typography className={classes.title} variant="h6" paragraph>
					{t('basic_search_title')}
				</Typography>
				<Typography className={classes.justifyText} variant="body1" paragraph>
					{t('basic_search_text')}
				</Typography>
				<Typography className={classes.boldText} variant="body2" paragraph>
					{t('metadata.year')} <br />
					{t('metadata.street')} <br />
					{t('metadata.house')} <br />
					{t('metadata.firstname')} <br />
					{t('metadata.surname')}
				</Typography>
				<Typography className={classes.title} variant="h6" paragraph>
					{t('search_in_connected_municipalities_title')}
				</Typography>
				<Typography className={classes.justifyText} variant="body1" paragraph>
					{t('search_in_connected_municipalities_prefix')}
					<b>{t('search_in_connected_municipalities_bold')}</b>
					{t('search_in_connected_municipalities_suffix')}
				</Typography>
				<Typography className={classes.title} variant="h6" paragraph>
					{t('advanced_search_title')}
				</Typography>
				<Typography className={classes.justifyText} variant="body1" paragraph>
					{t('advanced_search_text')}
				</Typography>
				<Typography className={classes.justifyText} variant="body1" paragraph>
					{t('advanced_search_criteria.text')}
				</Typography>
				<Typography className={classes.boldText} variant="body2" paragraph>
					{t('advanced_search_criteria.inventory_number')} <br />
					{t('advanced_search_criteria.volume')} <br />
					{t('advanced_search_criteria.page_number')}
				</Typography>
				<Typography className={classes.title} variant="h6" paragraph>
					{t('search_results_title')}
				</Typography>
				<Typography className={classes.justifyText} variant="body1" paragraph>
					{t('search_results_text')}
				</Typography>
				<Typography className={classes.title} variant="h6" paragraph>
					{t('archive_view_title')}
				</Typography>
				<Typography className={classes.justifyText} variant="body1" paragraph>
					{t('archive_view_text')}
				</Typography>
			</Grid>
			<Grid item xs={1} sm={2} />
		</>
	);
};

export default Help;
